import React from 'react';
import PrivacyPolicyPageStyles from './PrivacyPolicyPage.module.scss'
const PrivacyPolicyPage = () => {
    return (
        <div style={{ maxWidth: '800px', margin: '0 auto', padding: '40px', lineHeight: '1.6' }}>
            <div className={PrivacyPolicyPageStyles.title}><p> <strong  >ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ</strong><br /></p></div>
            <p>
                Для интернет-магазина «эпатажность» (https://epatazhnost.ru/)<br />
                Настоящая Политика конфиденциальности регулирует порядок сбора, использования, хранения и защиты персональных данных пользователей сайта https://epatazhnost.ru/ (далее — «Сайт»).</p>

            <p><strong>1. Общие положения</strong><br />
                1.1. Используя Сайт, Пользователь соглашается с условиями обработки его персональных данных в соответствии с настоящей Политикой.<br />
                1.2. Администрация Сайта обязуется соблюдать конфиденциальность полученной информации и обеспечивать ее защиту.<br />
                1.3. Политика действует в соответствии с законодательством РФ, в частности, Федеральным законом «О персональных данных» № 152-ФЗ.</p>

            <p><strong>2. Какие данные мы собираем?</strong><br />
                2.1. При регистрации, оформлении заказа или подписке на рассылку мы можем запросить:</p>

            <ul>
                <li>ФИО;</li>
                <li>контактный телефон;</li>
                <li>адрес электронной почты;</li>
                <li>адрес доставки;</li>
                <li>данные платежных систем (если осуществляется онлайн-оплата).</li>
            </ul>

            <p>2.2. Автоматически собираемые данные (cookie, IP-адрес, данные браузера, история посещений).</p>

            <p><strong>3. Цели обработки данных</strong><br />
                3.1. Обработка персональных данных осуществляется для:</p>

            <ul>
                <li>оформления и выполнения заказов;</li>
                <li>связи с Пользователем (уточнение деталей, информирование о статусе заказа);</li>
                <li>улучшения качества обслуживания и работы Сайта;</li>
                <li>рассылки рекламных и информационных материалов (с согласия Пользователя).</li>
            </ul>

            <p><strong>4. Условия передачи данных третьим лицам</strong><br />
                4.1. Администрация Сайта не передает персональные данные третьим лицам, за исключением:</p>

            <ul>
                <li>служб доставки (для выполнения заказа);</li>
                <li>платежных систем (для обработки транзакций);</li>
                <li>случаев, предусмотренных законодательством РФ.</li>
            </ul>

            <p><strong>5. Защита данных</strong><br />
                5.1. Применяются технические и организационные меры для предотвращения утечки или несанкционированного доступа.<br />
                5.2. Конфиденциальность платежных данных обеспечивается сервисами платежных систем.</p>

            <p><strong>6. Права пользователей</strong><br />
                6.1. Пользователь вправе:</p>

            <ul>
                <li>запросить доступ, исправление или удаление своих данных;</li>
                <li>отозвать согласие на обработку;</li>
                <li>отказаться от рекламных рассылок.</li>
            </ul>

            <p><strong>7. Изменения в Политике</strong><br />
                7.1. Администрация оставляет за собой право вносить изменения в Политику. Актуальная версия всегда доступна на Сайте.</p>

            <p><strong>8. Контакты</strong><br />
                8.1. Продавец: Чернецкий Владислав Станиславович<br />
                8.2. Телефон: +79647028310<br />
                8.3. Email: store@epatazhnost.world<br />
                8.4. Адрес: Москва, Чертаново Северное, 5кА</p>

            <p>Политика конфиденциальности: 15 апреля 2025</p>
        </div>
    );
};

export default PrivacyPolicyPage;
